export default "<p>outbuildings works!</p>\n";